var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),(_vm.isVisibleButton)?_c('button',{on:{"click":_vm.downloadPDF}},[_vm._v("Download PDF")]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pdf-content"}},[_c('h1',[_vm._v("Hello PDF")]),_c('p',[_vm._v("This is a sample PDF content without any images.")])])
}]

export { render, staticRenderFns }